module.exports = __webpack_public_path__ + "static/media/defaultImage.dbe719c3.svg";